<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex flex-column flex-md-row justify-content-between">
                            <!-- Sección de Título -->
                            <div>
                                <h6 class="mb-2 ms-2">Registros de Tiempo por Usuario</h6>
                            </div>
                            <div class="d-flex align-items-center">
                                Buscar:
                                <input type="text" class="form-control ms-2" v-model="searchQuery">
                            </div>
                            <div class="d-flex align-items-center">
                                De:
                                <input type="date" class="form-control ms-2 me-2" v-model="startDate">
                                A:
                                <input type="date" class="form-control ms-2" v-model="endDate">

                            </div>
                        </div>
                    </div>
                    <div class="card-body">

                        <div class="row">
                            <div class="table-responsive">
                                <table class="table table-bordered text-center align-middle">
                                    <thead>
                                        <th>
                                            Colaborador
                                        </th>
                                        <th>
                                            Total de horas
                                        </th>
                                        <th>
                                            Acciones
                                        </th>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(usr, idx) in filteredUsers" :key="idx">
                                            <td>{{ usr.name }} {{ usr.last_name }}</td>
                                            <td> {{ usr.total_user_hours.toFixed(1) }} hrs</td>
                                            <td>
                                                <button class="btn btn-warning mb-0">
                                                    <i class="bi bi-bar-chart"></i> Ver Estadísticas
                                                </button>
                                                <router-link class="btn btn-secondary mb-0 ms-2"
                                                    :to="{ path: `/user-time-records/${usr.user_id}` }">
                                                    <i class="bi bi-pencil"></i> Modificar Registros
                                                </router-link>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>

import { ref, computed, onMounted } from "vue"

import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;

const users = ref([])
const searchQuery = ref('')

const endDate = ref(new Date().toISOString().split('T')[0]);

const start = new Date();
start.setMonth(start.getMonth() - 1);
const startDate = ref(start.toISOString().split('T')[0]);

const filteredUsers = computed(() => {
    const query = searchQuery.value.toLowerCase();
    return users.value.filter(u =>
        (u.name?.toLowerCase().includes(query))
    );
});

const getUsers = async () => {

    const body = { start: startDate.value, end: endDate.value }

    try {
        const response = await axios.post(`${API_BASE_URL}/time-records-users`, body, {
            headers: {
                Authorization: `Bearer ${token}`, // Agrega el token en el header
            },
        });
        users.value = response.data; // Asigna los datos a variable `teams`

        console.log(users.value)
    } catch (error) {
        console.error('Error al obtener los datos:', error);
    }
}

onMounted(
    async () => {
        await getUsers()
    }
)

</script>